module.exports = __webpack_public_path__ + "static/img/top11.6dc7f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top11.png
// module id = /gD4
// module chunks = 208